import {
  CHANGE_LAYOUT,
  CHANGE_SIDEBAR_THEME,
  CHANGE_SIDEBAR_TYPE,
  CHANGE_TOPBAR_THEME,
  IS_LOADING,
  MENU_ACTIVED,
  SHOW_RIGHT_SIDEBAR,
  SHOW_SIDEBAR,
  SHOW_TOPBAR_INSIDE,
  TOGGLE_LEFTMENU,
  IS_TRANSACTION_NOT_FOUND,
  IS_MODAL_PAGE,
  IS_TRANSACTION_WITH_ERROR,
  IS_IFRAME_PAGE,
} from "./actionTypes";

export const isTransactionNotFound = isNotFound => ({
  type: IS_TRANSACTION_NOT_FOUND,
  payload: isNotFound,
});

export const isTransactionWithError = payload => ({
  type: IS_TRANSACTION_WITH_ERROR,
  payload: payload,
});

export const changeIsModalPage = isModal => ({
  type: IS_MODAL_PAGE,
  payload: isModal,
});

export const changeIsIframePage = isModal => ({
  type: IS_IFRAME_PAGE,
  payload: isModal,
});

export const changeLayout = layout => ({
  type: CHANGE_LAYOUT,
  payload: layout,
});

export const changeSidebarTheme = theme => ({
  type: CHANGE_SIDEBAR_THEME,
  payload: theme,
});

export const changeSidebarType = (sidebarType, isMobile) => {
  return {
    type: CHANGE_SIDEBAR_TYPE,
    payload: { sidebarType, isMobile },
  };
};

export const changeTopbarTheme = topbarTheme => ({
  type: CHANGE_TOPBAR_THEME,
  payload: topbarTheme,
});

export const showRightSidebarAction = isopen => ({
  type: SHOW_RIGHT_SIDEBAR,
  payload: isopen,
});

export const showTopbarInsideAction = (payload) => ({
  type: SHOW_TOPBAR_INSIDE,
  payload: payload, //{id, isActive, payload}
});

export const showSidebar = isopen => ({
  type: SHOW_SIDEBAR,
  payload: isopen,
});

export const toggleLeftmenu = isopen => ({
  type: TOGGLE_LEFTMENU,
  payload: isopen,
});

export const isLoading = isLoading => ({
  type: IS_LOADING,
  payload: isLoading,
});

export const changeMenuActived = (payload) => ({
  type: MENU_ACTIVED,
  payload: payload,
});